export const NetworkDaoProposalOnChain = {
  label: 'On-chain Proposal',
  desc: 'this will go in to embedded page',
};
